import { render } from "./NomenclatureLevel.vue?vue&type=template&id=045f0880&scoped=true"
import script from "./NomenclatureLevel.vue?vue&type=script&lang=js"
export * from "./NomenclatureLevel.vue?vue&type=script&lang=js"

import "./NomenclatureLevel.vue?vue&type=style&index=0&id=045f0880&lang=scss&scoped=true"

import exportComponent from "/builds/common/delivery-front/dev-factory/supplyweb/opticam/packages/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-045f0880"]])

export default __exports__